import React from 'react';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { ArrowRight, Check, Headphones } from 'react-feather';
import { Button } from '../../VuexyDesign/atoms/_index';
import { TextBold24 } from '../common/Text';
import { TextBold14, TextRegular16 } from '../../VuexyDesign/atoms/Text';
import { useIsDesktop } from '../../style/constants';

const DemoUpload = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation('upload');
  return (
    <div
      className={`bg-white d-flex flex-column align-items-center h-100 ${
        isDesktop ? 'p-3 mr-1' : 'p-2'
      }`}
      style={{ border: 'solid 2px #B9B9C3', borderRadius: '22px' }}
    >
      <Headphones size={75} color="red" />
      <TextBold24 className="mt-1 mb-2">
        {t('upload:uploadADemo') as string}
      </TextBold24>
      <div className="d-flex align-items-center flex-column">
        <div>
          <Check size={14} style={{ marginRight: '3px' }} />
          <TextBold14 className="mr-1">
            {t('upload:getFeedbackFromOthers') as string}
          </TextBold14>
        </div>
        <div>
          <Check size={14} style={{ marginRight: '3px' }} />
          <TextBold14>{t('upload:getInsights') as string}</TextBold14>
        </div>
      </div>
      <TextRegular16 className="mt-1">
        {t('upload:finetuneYourSkills') as string}
      </TextRegular16>
      <div className="my-1">
        <Link href="/upload">
          <Button outline color="primary" className="d-flex align-items-center">
            <>
              {t('upload:uploadNow') as string}{' '}
              <ArrowRight size={14} color="#f71454" />
            </>
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default DemoUpload;
